<template>
  <div>
    <a-table :columns="columns" row-key="organizationCourseSessionId" :pagination="false" :loading="tableLoading" :dataSource="tableDataSource">
      <div v-if="compare" slot="userCount" slot-scope="text">{{ text.settingUserCount || 0 }}/{{ text.userCount }}</div>
      <div v-else slot="userCount" slot-scope="text">{{ text.userCount || 0 }}/{{ text.totalCount }}</div>
      <div slot="action" class="action" slot-scope="text">
        <a @click="openConfigStudent(text)">配置学生</a>
        <a-popconfirm title="确认删除此课程？" @confirm="delCourse(text)">
          <a class="red">删除</a>
        </a-popconfirm>
      </div>
    </a-table>

    <!-- 配置学生 -->
    <a-modal v-model="student.visible" title="配置学生" @cancel="handleCancel" width="70%" :centered="true" :destroyOnClose="true">
      <template slot="footer">
        <div v-if="student.step == 1">
          <a-button @click="student.visible = false"> 取消 </a-button>
          <a-button :loading="student.confirmLoading" type="primary" @click="next(2)"> 下一步 </a-button>
        </div>
        <div v-if="student.step == 2">
          <a-button @click="next(1)"> 上一步 </a-button>
          <a-button :loading="student.confirmLoading" type="primary" @click="studentSubmit()"> 确定 </a-button>
        </div>
      </template>
      <a-spin :spinning="student.loading" style="min-height: 300px">
        <a-form-model ref="ruleForm" :model="student.form" :rules="student.rules" :label-col="{ span: 8 }" :wrapper-col="{ span: 10 }">
          <template v-if="student.step == 1">
            <a-form-model-item label="完成状态" prop="status">
              <a-checkbox-group v-model="student.form.status" @change="setStudent(courseChildItem)">
                <a-checkbox :value="2" name="type">已完成</a-checkbox>
                <a-checkbox :value="1" name="type">进行中</a-checkbox>
                <!-- <a-checkbox :value="0" name="type">未开始</a-checkbox> -->
              </a-checkbox-group>
            </a-form-model-item>
            <a-form-model-item label="班级选择" prop="checkedKeys">
              <a-tree
                checkable
                :key="student.treeKey"
                :replaceFields="{ children: 'childs', title: 'gradeClassName', key: 'gradeClassID' }"
                :defaultExpandAll="true"
                :tree-data="student.treeData"
                v-model="student.form.checkedKeys"
              />
            </a-form-model-item>
          </template>
          <template v-if="student.step == 2">
            <a-form-model-item label="班级选择" prop="checkedKeys">
              <a-tree :replaceFields="{ children: 'childs', key: 'gradeClassID' }" :key="student.treeKey" :defaultExpandAll="true" :tree-data="student.treeData1" />
            </a-form-model-item>
          </template>
        </a-form-model>
      </a-spin>
    </a-modal>
    <ConfigStudent ref="configStudentRef" />
  </div>
</template>

<script>
import ConfigStudent from './configStudent.vue'
export default {
  name: 'StepsSecondAddCourse',
  props: {
    compare: {
      default: 0,
      type: [Number, String],
    },
    tableDataSource: Array,
    tableLoading: {
      type: Boolean,
      default: false,
    },
    IsDetails: {
      type: Boolean,
      default: false,
    },
    organization: {
      type: Boolean,
      default: false,
    },
  },
  inject: ['update'],
  components: { ConfigStudent },
  data() {
    return {
      columns: [
        { title: '测评名称', dataIndex: 'organizationCourseName' },
        { title: '资源名称', dataIndex: 'courseName' },
        { title: '课时名称', dataIndex: 'courseSessionResourceName' },
        { title: '学生数', scopedSlots: { customRender: 'userCount' } },
        { title: '操作', scopedSlots: { customRender: 'action' } },
      ],
      student: {
        visible: false,
        loading: false,
        confirmLoading: false,
        setStatus: false,
        step: 1,
        form: {
          status: [2],
          checkedKeys: [],
        },
        treeKey: Date.now(),
        treeData: [],
        treeData2: [],
        rules: {
          status: [{ type: 'array', required: true, message: '请选择完成状态', trigger: 'change' }],
          checkedKeys: [{ type: 'array', required: true, message: '请选择班级', trigger: 'change' }],
        },
      },
      courseChildItem: {},
    }
  },
  created() {
    if (this.organization && this.columns.length <= 5) {
      this.columns.unshift({ title: '机构名称', dataIndex: 'organizationName' })
    }
    if (this.IsDetails && this.columns.length > 4) {
      this.columns.pop()
    }
    if (this.compare == 1) {
      this.columns = [
        { title: '测评名称', dataIndex: 'organizationCourseName' },
        { title: '资源名称', dataIndex: 'courseResourceName' },
        { title: '课时名称', dataIndex: 'courseSessionName' },
        { title: '学生数', scopedSlots: { customRender: 'userCount' } },
        { title: '操作', scopedSlots: { customRender: 'action' } },
      ]
    }
    if (this.compare == 2) {
      this.columns = [
        { title: '机构名称', dataIndex: 'organizationName' },
        { title: '测评名称', dataIndex: 'organizationCourseName' },
        { title: '资源名称', dataIndex: 'courseResourceName' },
        { title: '课时名称', dataIndex: 'courseSessionName' },
        { title: '学生数', scopedSlots: { customRender: 'userCount' } },
        { title: '操作', scopedSlots: { customRender: 'action' } },
      ]
    }
  },
  methods: {
    async openConfigStudent(record) {
      const options = {
        groupReportCourseSessionId: record.groupReportCourseSessionId || record.id,
        organizationId: record.organizationId,
        groupReportId: this.$store.getters['organization/getReportInfo'].id,
        success: () => {
          this.$emit('renewData')
        },
      }
      await this.$refs['configStudentRef'].showModal(options)
    },
    // 删除课程
    delCourse(val) {
      this.$http.ReportService.delGroupReportCourse(val.groupReportCourseSessionId)
        .then((res) => {
          const { status, message } = res
          this.$message.success(message)
          this.$emit('renewData')
          this.update && this.update()
        })
        .finally(() => {
          this.$emit('loading', false)
        })
    },
    handleCancel() {
      console.log(this.student.form.status)
      this.student = {
        ...this.student,
        step: 1,
        form: {
          status: [2],
          checkedKeys: [],
        },
        treeKey: Date.now(),
        treeData: [],
        setStatus: false,
      }
      console.log(this.student.form.status)
    },
  },
}
</script>

<style scoped>
.search-item {
  width: 180px;
  margin-bottom: 15px;
}
</style>
